export { ExcelExportComponent } from './excel-export.component';
export { ExcelExportModule } from './excel-export.module';
export { ColumnBase } from './columns/column-base';
export { ColumnComponent } from './columns/column.component';
export { ColumnGroupComponent } from './columns/column-group.component';
export { FooterTemplateDirective } from './columns/footer-template.directive';
export { GroupFooterTemplateDirective } from './columns/group-footer-template.directive';
export { GroupHeaderTemplateDirective } from './columns/group-header-template.directive';
export * from './ooxml/workbook';
export * from '@progress/kendo-ooxml';



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-excel-export/dist/es/main.js
// module id = ../../../../@progress/kendo-angular-excel-export/dist/es/main.js
// module chunks = vendor